import React  from 'react';
import PropTypes from 'prop-types';
import { withTranslation , Trans} from 'react-i18next';
import { Link } from 'react-router-dom';
import { RaceNameInput } from './RaceNameInput';
// import { CountryPicker, StatePicker } from '../../shared/CountryStatePicker';
import { DatePicker } from '../../../components/shared/Elements';
import { googleApiKey, GeoSuggestInput } from '../../../components/shared/GeoSuggestInput';
// import { TimePicker } from '../../shared/TimePicker';
import { inputSpacing } from './styles';
import { colors } from '../../../shared/styles';
import moment from 'moment';

const RaceDetailsComponent = (
  {
    name,
    city,
    stateProvId,
    countryId,
    isMobile,
    date,
    url,
    showRequiredFields,
    existingEvent,
    fetchRacesTypeAhead,
    redirectToNewCreatePage,
    fetchCountries,
    fetchStates,
    onPickedName: onPickedNameProps,
    onPickedCity,
    onPickedStateProvId: onPickedStateProvIdProps,
    onPickedDate: onPickedDateProps,
    onPickedUrl,
    onPickedCountry,
    raceExists,
    raceUrl,
    websiteValid,
    t
  }) => {

  const disabled = !!existingEvent;
  const momentDate = moment(date);
  const hh = momentDate.hours();
  const mm = momentDate.minutes();

  const onPickedName = (name) => onPickedNameProps(name);

  //clicked on an option or keyed Enter on a focused option
  const onNameOptionPicked = ({MasterID, MasterName}) => {
    //redirect to the picked event (if different from current page's masterID)
    redirectToNewCreatePage(MasterID);

    //show what we picked in input field - in case we stay on same page
    //because already on this masterID
    onPickedName(MasterName);
  };

  const onPickedStateProvId = (stateProvId) =>
    onPickedStateProvIdProps(stateProvId);

  const onPickedDate = (date, {hh, mm}) => {
    date = moment(date).hours(hh).minutes(mm).seconds(0);
    onPickedDateProps(new Date(date.valueOf()));
  };

  const onTypedUrl = ({target: {value}}) => onPickedUrl(value);

  const handleCountryChange = (countryId) => {
    onPickedStateProvId(countryId + '_0');
    onPickedCountry(countryId);
  };

  const handleStateChange = (stateProvId) => onPickedStateProvId(stateProvId);

  const onChange = (type, value = {}) =>
    onPickedDateProps(value instanceof Date ? value : new Date(date.valueOf()));

  const floatingLabelStyle = {color: colors.darkGrey};
  const eventExistsStyle = {color: 'red', fontSize: '14px'};
  const eventExistsLinkStyle = {color: 'red', textDecoration: 'underline'};

  const dateProps = {
    value: new Date(date.valueOf()) || null,
    label: t('Date'),
    onChange: (e, value) => onChange('from', value),
    onClear: () => onChange('from', null),
    labelColor: floatingLabelStyle.color,
    isMobile
  };
  return (
    <div>
      <div style={{marginTop: inputSpacing}}>
        <RaceNameInput
          name={name}
          width={'100%'}
          showRequired={showRequiredFields}
          redirectToNewCreatePage={redirectToNewCreatePage}
          fetchRacesTypeAhead={fetchRacesTypeAhead}
          onChange={onPickedName}
          onOptionPicked={onNameOptionPicked}
          disabled={disabled}
        />
      </div>

      <div style={{marginTop: inputSpacing}}>
        <div
          style={{
            position:'relative',
            display:'inline-block',
            paddingRight:30,
            minWidth:200,
            verticalAlign:'top',
            width:'50%'
          }}>
          <div>
            <GeoSuggestInput
              inputProps={{
                id: 'location-filters'
              }}
              term={typeof(city) === 'object' ? city.description : city}
              width='100%'
              disabled={disabled}
              useCurrentLocationOption={true}
              labelColor={floatingLabelStyle.color}
              errorText={
                !city && showRequiredFields ? t('City is required') : ''
              }
              onChange={({target: {value}}) => onPickedCity(value)}
              onPicked={(city) => onPickedCity(city)}
              onPickedCurrentLocation={({label}) => onPickedCity(label)}
              googleApiKey={googleApiKey}
            />
          </div>
        </div>

        <div
          style={{
            display:'inline-block',
            verticalAlign:'top',
            width:'50%'
          }}>
          {/*<StatePicker*/}
          {/*  fetchStates={fetchStates}*/}
          {/*  countryId={countryId}*/}
          {/*  value={stateProvId ? stateProvId : null}*/}
          {/*  disabled={disabled}*/}
          {/*  id='state-select'*/}
          {/*  useMaterialUi={true}*/}
          {/*  onChange={handleStateChange}*/}
          {/*  stateAbbrevMode={false}*/}
          {/*/>*/}
        </div>
      </div>

      <div style={{marginTop: inputSpacing, width:'100%'}}>
        {/*<CountryPicker*/}
        {/*  fetchCountries={fetchCountries}*/}
        {/*  value={countryId}*/}
        {/*  disabled={disabled}*/}
        {/*  city={city}*/}
        {/*  id='country-select'*/}
        {/*  useMaterialUi={true}*/}
        {/*  onChange={handleCountryChange}*/}
        {/*/>*/}
      </div>

      <div style={{marginTop: inputSpacing}}>
        <Trans>
          <div style={{display:'inline-block', verticalAign:'top'}}>
            {/*<DatePicker {...dateProps} />*/}
          </div>

        <div
          style={{
            display:'inline-block',
            paddingTop:41,
            verticalAlign:'top',
            marginLeft:13,
            marginRight:13,
          }}>
          at
        </div>

          <div style={{display:'inline-block', verticalAlign:'top'}}>
            {/*<TimePicker*/}
            {/*  hh={hh}*/}
            {/*  mm={mm}*/}
            {/*  onChange={({hh, mm}) => onPickedDate(date, {hh, mm})}*/}
            {/*/>*/}
          </div>
        </Trans>

      </div>


      {
        raceExists &&
        <div style={eventExistsStyle}>
          <span>{t('An event already exists with that date.')} </span>
          <Link to={raceUrl} style={eventExistsLinkStyle}>
            {t('Visit Event Page')}
          </Link>
        </div>
      }

      <div style={{marginTop: inputSpacing}}>
        {/*<TextField*/}
        {/*  id={'website-input'}*/}
        {/*  style={{width:'100%'}}*/}
        {/*  floatingLabelText={t('Web Site')}*/}
        {/*  floatingLabelFixed={true}*/}
        {/*  floatingLabelStyle={floatingLabelStyle}*/}
        {/*  underlineFocusStyle={{borderColor: colors.blue}}*/}
        {/*  onChange={onTypedUrl}*/}
        {/*  value={url}*/}
        {/*  disabled={disabled}*/}
        {/*/>*/}
        { !websiteValid && <div style={{ color: colors.red }}>{t('Please provide valid URL')}</div> }
      </div>

    </div>
  );
};

const RaceDetails = withTranslation()(RaceDetailsComponent);

RaceDetails.propTypes = {
  existingEvent: PropTypes.object,
  redirectToNewCreatePage: PropTypes.func.isRequired,
  fetchRacesTypeAhead: PropTypes.func.isRequired,
  fetchCountries: PropTypes.func.isRequired,
  fetchStates: PropTypes.func.isRequired,
  name: PropTypes.string,
  city: PropTypes.string,
  stateProvId: PropTypes.string,
  date: PropTypes.instanceOf(Date),
  url: PropTypes.string,
  showRequiredFields: PropTypes.bool.isRequired,
  onPickedName: PropTypes.func.isRequired,
  onPickedCity: PropTypes.func.isRequired,
  onPickedDate: PropTypes.func.isRequired,
  onPickedStateProvId: PropTypes.func.isRequired,
  onPickedUrl: PropTypes.func.isRequired
};

export default RaceDetails;



/** WEBPACK FOOTER **
 ** ./components/race/create/RaceDetails.js
 **/